<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
        <v-btn v-on="on" v-bind="$attrs" @click="copyToClipboard">
        <span v-html="clipboardIcon"/>
      </v-btn>
    </template>
    <span>{{ clipboardTooltip }}</span>
  </v-tooltip>
</template>

<script>
import { defineComponent, ref, computed } from 'vue';
import { getCurrentInstance } from 'vue'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true
    }
  },
  setup(props, context){
    const root = getCurrentInstance();
    const copied = ref(false);
    const error = ref(false);

    const clipboardIcon = computed(()=>{
      if (copied.value){
        return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" data-icon="mdi:clipboard-check-outline" class="iconify" style="vertical-align: -0.125em; transform: rotate(360deg);"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 7h10V5h2v14H5V5h2v2m.5 6.5L9 12l2 2l4.5-4.5L17 11l-6 6l-3.5-3.5z" fill="currentColor"></path></svg>`  
      } else if (error.value){
        return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" data-icon="mdi:clipboard-remove-outline" class="iconify" style="vertical-align: -0.125em; transform: rotate(360deg);"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h14c1.11 0 2-.89 2-2V5a2 2 0 0 0-2-2m-7 0c.55 0 1 .45 1 1s-.45 1-1 1s-1-.45-1-1s.45-1 1-1m7 16H5V5h2v2h10V5h2v14m-3.46-8.12L13.41 13l2.13 2.12l-1.42 1.42L12 14.41l-2.12 2.13l-1.41-1.42L10.59 13l-2.12-2.12l1.41-1.41L12 11.59l2.12-2.12l1.42 1.41z" fill="currentColor"></path></svg>`
      }
      return `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24" data-icon="mdi:clipboard-outline" class="iconify" style="vertical-align: -0.125em; transform: rotate(360deg);"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-7 0a1 1 0 0 1 1 1a1 1 0 0 1-1 1a1 1 0 0 1-1-1a1 1 0 0 1 1-1M7 7h10V5h2v14H5V5h2v2z" fill="currentColor"></path></svg>`  
    })

    const clipboardTooltip = computed(()=>{
      if (copied.value){
        return `${root.proxy.$t('clipboard.copied')}!`  
      } else if (error.value){
        return `${root.proxy.$t('clipboard.not_copied')}`  
      }
      return `${root.proxy.$t('clipboard.copy_action')}`  
    })

    const copyToClipboard = ()=>{
      navigator.clipboard.writeText(props.text)
      .then(() => {
        copied.value = true;
        context.emit('copied');
      })
      .catch(e => {
        console.error(e);
        error.value = true;
        context.emit('error', e);
      })
    }

    return {
      clipboardIcon,
      clipboardTooltip,
      copyToClipboard
    }
  }
})
</script>
